var map = {
	"./esp-e-paper-frame-1.jpg": 386,
	"./esp-e-paper-frame-2.jpg": 285,
	"./esp-e-paper-frame-3.jpg": 9152,
	"./led-matrix-station-1.png": 8477,
	"./map-viewer-1.png": 1432,
	"./one-d-pong-1.jpg": 375,
	"./one-d-pong-2.png": 844,
	"./stiftung-haus-pius-1.jpg": 2617,
	"./stiftung-haus-pius-2.jpg": 5502
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2516;